
import { Component, OnInit, TemplateRef } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SMSService } from 'src/app/services/SMS/sms.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css']
})
export class GroupComponent implements OnInit {

  Submitted: boolean = false;
  GroupList: any;
  GroupDeopDownList: any;
  GroupContactList: any;
  Group: any;
  Count: number = 0;
  ContactList: any;
  selectedFile: any;
  ContactSubmitted: boolean = false;
  ContactCommaSepList: any;

  constructor(private SmsService: SMSService, private LookupService: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  GroupModel = {
    GroupID: 0,
    GroupName: '',
    IsActive: true,
  };

  Clear() {
    this.GroupModel.GroupID = 0;
    this.GroupModel.GroupName = '';
    this.GroupModel.IsActive = true;
    this.Submitted = false;
  };


  GetGroup  () {
    this.spinnerService.show();
    this.SmsService.GetGroup().subscribe((response: any) => {
      this.GroupList = response.GroupList;
      this.spinnerService.hide();
    });
  };


  SaveGroup(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.SmsService.SaveGroup(JSON.stringify(this.GroupModel)).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetGroup();
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }
  };

  GroupMarkActive(item) {
    this.GroupModel.GroupID = item.GroupID;
    this.GroupModel.IsActive = item.IsActive == true ? false : true;
    this.SmsService.GroupMarkActive(JSON.stringify(this.GroupModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.Clear();
        this.GetGroup();
      }
      this.globalHelper.CheckActionStatus(data);
    });

  };

  Edit(obj) {

    this.GroupModel.GroupID = obj.GroupID;
    this.GroupModel.GroupName = obj.GroupName;
    this.GroupModel.IsActive = obj.IsActive;


  };

  ngOnInit() {
    this.GetAllGroup();
    this.GetGroup();
  }

  GetAllGroup() {
    this.LookupService.GetLookupsList('SMSGroup', '').subscribe((data: any) => {
      this.GroupDeopDownList = data.LookupItems;
    });

  }

  // Open Model

  SelectModel = {
    Active: false,
  };

  GetGroupContact(item) {
    this.spinnerService.show();
    this.GroupContactList = item.ContactList;
    if (this.GroupContactList != null) {
      this.Group = item.GroupName;
    }
    this.spinnerService.hide();

  };

  SelectAll() {
    if (this.SelectModel.Active) {
      for (var i = 0; i < this.GroupContactList.length; i++) {
        this.GroupContactList[i].IsDelete = true;
      }
    }
    if (this.SelectModel.Active == false) {
      for (var i = 0; i < this.GroupContactList.length; i++) {
        this.GroupContactList[i].IsDelete = false;
      }
    }
  }

  ChangeSelect(item) {
    this.Count = 0;
    for (var i = 0; i < this.GroupContactList.length; i++) {
      if (this.GroupContactList[i].IsDelete) {
        this.Count = this.Count + 1;
      }
    }

    if (this.Count == this.GroupContactList.length) {
      this.SelectModel.Active = true;
    }
    else {
      this.SelectModel.Active = false;
    }
  }

  DeleteContact() {

    this.ContactList = [];
    var CountContact = 0;
    for (var i = 0; i < this.GroupContactList.length; i++) {
      if (this.GroupContactList[i].IsDelete) {
        CountContact = CountContact + 1;
        var item = {
          ContactID: this.GroupContactList[i].ContactID
        }
        this.ContactList.push(item);
      }
    }
    if (CountContact == 0) {
      return;
    }
    this.spinnerService.show();
    this.SmsService.DeleteContact(JSON.stringify(this.ContactList)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.SelectModel.Active = false;
      this.GetGroup();
      this.globalHelper.CheckActionStatus(data);
    });
  };


  // Upload Contact


  ContactModel = {
    IsUpload: false,
    GroupID: 0,
    Contacts: '',
  };

  // Upload File

  onUpload(event: any) {
    this.selectedFile = event.target.files[0];
  }

  ValidationContact() {
    return this.ContactModel.GroupID == 0;
  }
  SaveContact() {
    this.ContactSubmitted = true;
    if (!this.ValidationContact()) {
      this.spinnerService.show();
      this.SmsService.SaveContact(this.ContactModel.GroupID, this.selectedFile).subscribe((data: any) => {
        this.spinnerService.hide();
        this.ContactSubmitted = false;
        this.SelectModel.Active = false;
        this.ContactModel.IsUpload = false;

        this.GetGroup();
        this.globalHelper.CheckActionStatus(data);
      });
    }
  };
  GetCommaContact() {
    this.ContactCommaSepList = [];
   
    var ContactCommaSep = this.ContactModel.Contacts.split(',');
    for (var i = 0; i < ContactCommaSep.length; i++) {
      ContactCommaSep[i] = ContactCommaSep[i].replace(/^\s*/, "").replace(/\s*$/, "");
     
      var model = {
        'Mobile': ContactCommaSep[i]
      }
      this.ContactCommaSepList.push(model);
    }

  }

  SaveContactCommaSeperated() {
    this.ContactSubmitted = true;
    if (!this.ValidationContact()) {
      this.GetCommaContact();
      this.spinnerService.show();
      this.SmsService.SaveContactCommaSeperated(this.ContactModel.GroupID, JSON.stringify(this.ContactCommaSepList)).subscribe((data: any) => {
        this.SelectModel.Active = false;
        this.ContactSubmitted = false;
        this.spinnerService.hide();
        this.GetGroup();
        if (data.webResponse.Status) {
          this.ContactModel.GroupID = 0;
          this.ContactCommaSepList = [];
          this.ContactModel.Contacts = '';
        }
        this.globalHelper.CheckActionStatus(data);
      });
    }
  };

   // Download

GroupListDownload  () {
    this.JSONToCsvConverterGroupList(this.GroupList, 'Group_List', true);
};

ContactListDownload  () {
    this.JSONToCsvConverterContactList(this.GroupContactList, 'Contact_List', true);
};

 JSONToCsvConverterContactList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
        var row = "";
        row += 'Sr. No.' + ',';
        row += 'Group' + ',';
        row += 'Name' + ',';
        row += 'Mobile' + ',';
        row += 'DOB' + ',';
        row = row.slice(0, -1);
        CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
        var sno = i + 1;
        var row = "";
        row += '"' + sno + '",';
        row += '"' +this.Group + '",';
        var Name = '';
        if (arrayData[i].Name != null) {
            Name = arrayData[i].Name;
        }
        row += '"' + Name + '",';
        row += '"' + arrayData[i].Mobile + '",';
        var DOB = '';
        if (arrayData[i].DOB != null) {
            DOB =moment(arrayData[i].DOB).format('DD-MMM-YYYY');
        }
        row += '"' + DOB + '",';
        row.slice(0, row.length - 1);
        CSV += row + '\r\n';
    }
    if (CSV == '') {
        alert('Invalid Data');
        return;
    }
    var FileName = ReportTitle + '_' +this.Group + '_' + moment(new Date()).format('DD-MMM-YYYY');

    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
}
JSONToCsvConverterGroupList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
        var row = "";
        row += 'Sr. No.' + ',';
        row += 'Group' + ',';
        row += 'Name' + ',';
        row += 'Mobile' + ',';
        row += 'DOB' + ',';               
        row = row.slice(0, -1);
        CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
        if (arrayData[i].ContactList != null) {
            for (var j = 0; j < arrayData[i].ContactList.length; j++) {

                var sno = i+j + 1;
                var row = "";
                row += '"' + sno + '",';
                row += '"' + arrayData[i].GroupName + '",';
                var Name = '';
                if (arrayData[i].ContactList[j].Name!=null) {
                    Name = arrayData[i].ContactList[j].Name;
                }
               
                row += '"' + Name + '",';
                row += '"' + arrayData[i].ContactList[j].Mobile + '",';
                var DOB = '';
                if (arrayData[i].ContactList[j].DOB != null) {
                    DOB = moment( arrayData[i].ContactList[j].DOB).format('DD-MMM-YYYY') ;
                }
                row += '"' + DOB + '",';
                row.slice(0, row.length - 1);
                CSV += row + '\r\n';
            }
        }
        
    }
    if (CSV == '') {
        alert('Invalid Data');
        return;
    }
    var FileName = ReportTitle + '_' + moment(new Date()).format('DD-MMM-YYYY');

    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
}

}

